export default __webpack_public_path__ + "static/media/8W3A2099.8c542592.jpg";